import Notifications from './Notifications'

export default [{
  path: '/notifications',
  name: 'Notifications',
  component: Notifications,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Notifications'}
}]



// WEBPACK FOOTER //
// ./src/pages/notification/router.js